module.exports = __webpack_public_path__ + "img/message.1e1655e6.svg";